import React, {useEffect} from "react";
import Highcharts from "highcharts";

export default function ({data, id}) {
    useEffect(() => {
        if (data.length > 0) {
            const options = {
                chart: {
                    type: 'line',
                    zooming: {
                        type: 'x'
                    }
                },
                title: {
                    text: undefined
                },
                xAxis: {
                    type: 'datetime'
                },
                yAxis: {
                    title: {
                        text: undefined
                    }
                },
                plotOptions: {
                    series: {
                        marker: {
                            symbol: 'circle',
                            fillColor: 'var(--highcharts-background-color, #ffffff)',
                            enabled: true,
                            radius: 2.5,
                            lineWidth: 1,
                            lineColor: null
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                series: data
            }
            Highcharts.chart('skill-graph-' + id, options);
        }
    }, [data]);

    function renderEmpty() {
        if (data.length <= 0) {
            return 'No data';
        }

        return null;
    }

    return (
        <div>
            {renderEmpty()}
            <div id={"skill-graph-" + id}/>
        </div>
    );
}
